import {Component,Inject, Input, Output, EventEmitter, OnInit} from 'ng-metadata/core';
import {FormBuilderEnums} from '../../../infra/formBuilder/formBuilder.service';
import { forEach } from 'angular';
import {SelfRegistrationService} from './selfRegistration.service';


@Component({
selector: 'prm-self-registration',
templateUrl: 'components/security/login/selfRegistration/selfRegistration.html',
})

export class PrmSelfRegistration implements OnInit{
    private formData: Object = {};
    private registrationType = {
        key: 'registrationType',
        name: 'registrationType',
        label: 'nui.ngrs.selfRegistration.TYPE',
        value: '',
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        uiType: FormBuilderEnums.UI_TYPE.RADIO_BUTTON,
        mandatory: true, mandatoryIndicator: true,
        options:[
            {
                label:'nui.ngrs.selfRegistration.INDIVIDUAL_TYPE',
                value:'individual'
            },
            {
                label:'nui.ngrs.selfRegistration.ORGANIZATION_TYPE',
                value:'organization'
            }
        ],
        events: {
            onClick: this.onClick.bind(this),
            params: []
        }
    };
    private userName = { name: 'userName', label: 'nui.ngrs.selfRegistration.USER_NAME', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private password = { name: 'password', label: 'nui.ngrs.selfRegistration.PASSWORD', uiType: FormBuilderEnums.UI_TYPE.TEXT, inputType:'password' ,mandatory: true, mandatoryIndicator: true };
    private confirmPassword = { name: 'confirmPassword', label: 'nui.ngrs.selfRegistration.CONFIRM_PASSWORD', uiType: FormBuilderEnums.UI_TYPE.TEXT, inputType:'password', mandatory: true, mandatoryIndicator: false };
    private companyName = { name: 'companyName', label: 'nui.ngrs.selfRegistration.COMPANY_NAME', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private firstName = { name: 'firstName', label: 'nui.ngrs.selfRegistration.FIRST_NAME', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private lastName = { name: 'lastName', label: 'nui.ngrs.selfRegistration.LAST_NAME', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private email = { name: 'email', label: 'nui.ngrs.selfRegistration.EMAIL', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private addressLine1 = { name: 'addressLine1', label: 'nui.ngrs.selfRegistration.ADDRESS_LINE_1', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private addressLine2 = { name: 'addressLine2', label: 'nui.ngrs.selfRegistration.ADDRESS_LINE_2', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator: false };
    private city = { name: 'city', label: 'nui.ngrs.selfRegistration.CITY', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private state = { name: 'state', label: 'nui.ngrs.selfRegistration.STATE', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private zipCode = { name: 'zipCode', label: 'nui.ngrs.selfRegistration.ZIP_CODE', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private primaryContactFirstName = { name: 'primaryContactFirstName', label: 'nui.ngrs.selfRegistration.PRIMARY_CONTACT_FIRST_NAME', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private primaryContactLastName = { name: 'primaryContactLastName', label: 'nui.ngrs.selfRegistration.PRIMARY_CONTACT_LAST_NAME', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private primaryContactEmail = { name: 'primaryContactEmail', label: 'nui.ngrs.selfRegistration.PRIMARY_CONTACT_EMAIL', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private phoneNumber = { name: 'phoneNumber', label: 'nui.ngrs.selfRegistration.PHONE_NUMBER', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private maximumRequestCost = { name: 'maximumRequestCost', label: 'nui.ngrs.selfRegistration.MAXIMUM_REQUEST_COST', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator: false };
    private complianceStatement = {
        name: 'complianceStatement',
        uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
        mandatory: true,
        mandatoryIndicator: true,
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        value: '',
        options: [
            {
                name: 'complianceStatement',
                value: false
            }
        ]
    }
    private country = {
        name: 'country',
        label: 'nui.ngrs.selfRegistration.COUNTRY',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: true
    };
    private showPasswordValidationMsg = false;
    private showUserValidationMsg = false;
    private showMaximumRequestCostValidationMsg = false;
    private fieldsVisibilityMap;
    private registerInProgress = false;
    private userErrorMsg;
    private showForm = false;

    private billingContactName = { name: 'billingContactName', label: 'nui.ngrs.selfRegistration.BILLING_CONTACT_NAME', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private billingEmailAddress = { name: 'billingEmailAddress', label: 'nui.ngrs.selfRegistration.BILLING_EMAIL_ADDRESS', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private billingAddressLine1 = { name: 'billingAddressLine1', label: 'nui.ngrs.selfRegistration.BILLING_ADDRESS_LINE_1', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private billingAddressLine2 = { name: 'billingAddressLine2', label: 'nui.ngrs.selfRegistration.BILLING_ADDRESS_LINE_2', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: false, mandatoryIndicator: false };
    private billingCity = { name: 'billingCity', label: 'nui.ngrs.selfRegistration.BILLING_CITY', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private billingStateProvince = { name: 'billingStateProvince', label: 'nui.ngrs.selfRegistration.BILLING_STATE_PROVINCE', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private billingPostalCode = { name: 'billingPostalCode', label: 'nui.ngrs.selfRegistration.BILLING_POSTAL_CODE', uiType: FormBuilderEnums.UI_TYPE.TEXT, mandatory: true, mandatoryIndicator: true };
    private billingComplianceStatement = {
        name: 'billingComplianceStatement',
        uiType: FormBuilderEnums.UI_TYPE.CHECK_BOX,
        mandatory: false,
        mandatoryIndicator: false,
        fieldType: FormBuilderEnums.FIELD_TYPE.STRING,
        value: 'true',
        options: [
            {
                name: 'billingComplianceStatement',
                value: true
            }
        ]
    }
    private billingCountry = {
        name: 'billingCountry',
        label: 'nui.ngrs.selfRegistration.BILLING_COUNTRY',
        uiType: FormBuilderEnums.UI_TYPE.DROP_DOWN,
        mandatory: true
    };

    @Output() private cancelRegistration = new EventEmitter<Object>();
    @Output() private loginUserDetails = new EventEmitter<Object>();
    private showFormMessage = false;
    private formMessages: Object = {};
    private formMessage: string;

    constructor(private selfRegistrationService : SelfRegistrationService,
                @Inject('$timeout') private $timeout: ng.ITimeoutService) {
        this.selfRegistrationService.getCountryList().then((response) => {
            this.setCountryOptions(response);
            this.setVisibilityMap(response);
            this.showForm = true;
        });
        this.selfRegistrationService.getFormMessages().then((response) => {
            this.setFormMessages(response);
            this.setShowFormMessage("individual");
        });
    }


    ngOnInit() {
        this.formData['registrationType'] = "individual";
        this.complianceStatement.options[0].label = 'nui.ngrs.selfRegistration.INDIVIDUAL_COMPLIANCE_STATEMENT';
        this.billingComplianceStatement.options[0].label = 'nui.ngrs.selfRegistration.BILLING_COMPLIANCE_STATEMENT';
        this.formData['billingComplianceStatement'] = 'Yes';
    }

    showFields(){
        return (this.formData && this.formData['registrationType']);
    }

    showIndividualFields(){
        return (this.formData && this.formData['registrationType'] && this.formData['registrationType'] == 'individual');
    }

    showOrganizationFields(){
        return (this.formData && this.formData['registrationType'] && this.formData['registrationType'] == 'organization');
    }

    isFormEnabled(fieldCode){
        if(fieldCode == 'COMPLIANCE_STATEMENT'){
            fieldCode = this.formData['registrationType'] == 'individual' ? 'INDIVIDUAL_COMPLIANCE_STATEMENT' : 'ORGANIZATION_COMPLIANCE_STATEMENT';
        }
        if(this.fieldsVisibilityMap && this.fieldsVisibilityMap["nui.ngrs.selfRegistration." + fieldCode] == false){
            return false;
        }
        return true;
    }

    clearForm(){
        let type = this.formData['registrationType'];
        this.formData = {};
        this.formData['registrationType'] = type;
        this.showPasswordValidationMsg = false;
    }

    onClick(){
        if(this.formData['registrationType'] == 'individual'){
            this.complianceStatement.options[0].label = 'nui.ngrs.selfRegistration.INDIVIDUAL_COMPLIANCE_STATEMENT';
        }else {
            this.complianceStatement.options[0].label = 'nui.ngrs.selfRegistration.ORGANIZATION_COMPLIANCE_STATEMENT';
        }
        this.setShowFormMessage(this.formData['registrationType']);
    }

    submitForm(){
        this.registerInProgress = true;
        this.showPasswordValidationMsg = false;
        this.showUserValidationMsg = false;
        this.showMaximumRequestCostValidationMsg = false;
        if(this.isFormValid()){
            this.selfRegistrationService.createNewUser(this.formData).then((response) => response.status=="success" ? this.login(response) : this.handleError(response));
        }else{
            this.registerInProgress = false;
        }
    }

    isFormValid(){
        if((this.isFormEnabled('USER_NAME') && !this.formData['userName']) || (this.isFormEnabled('PASSWORD') && !this.formData['password']) || (this.isFormEnabled('CONFIRM_PASSWORD') && !this.formData['confirmPassword'])
            || (this.isFormEnabled('ADDRESS_LINE_1') && !this.formData['addressLine1']) || (this.isFormEnabled('CITY') && !this.formData['city']) || (this.isFormEnabled('STATE') && !this.formData['state'])
            || (this.isFormEnabled('ZIP_CODE') && !this.formData['zipCode']) || (this.isFormEnabled('PHONE_NUMBER') && !this.formData['phoneNumber'])
            || (this.isFormEnabled('COMPLIANCE_STATEMENT') && !this.formData['complianceStatement'])){
            return false;
        }

        if(this.formData['registrationType'] == 'individual' && !this.isIndividualFormValid()){
            return false;
        }else if(this.formData['registrationType'] == 'organization' && !this.isOrganizationFormValid()){
            return false;
        }
        if(this.isFormEnabled('PASSWORD') && this.isFormEnabled('CONFIRM_PASSWORD') && this.formData['password'] != this.formData['confirmPassword']){
            this.showPasswordValidationMsg = true;
            this.$timeout(() => {
                let element = document.getElementById("password_validation_msg");
                if (element) {
                    element.setAttribute('tabindex', '-1');
                    element.focus();
                    element.setAttribute('tabindex', '0');
                }
            }, 100);
            return false;
        }

        if(this.isFormEnabled('MAXIMUM_REQUEST_COST') && this.formData['maximumRequestCost']!=null && this.formData['maximumRequestCost']!="" && !this.isMaximumRequestCostNumeric())
        {
            this.showMaximumRequestCostValidationMsg = true;
            this.$timeout(() => {
                let element = document.getElementById("maximum_request_cost_validation_msg");
                if (element) {
                    element.setAttribute('tabindex', '-1');
                    element.focus();
                    element.setAttribute('tabindex', '0');
                }
            }, 100);
            return false;
        }

        if(!this.isBillingComplianceChecked()){
            if((this.isFormEnabled('BILLING_CONTACT_NAME') && !this.formData['billingContactName']) || (this.isFormEnabled('BILLING_EMAIL_ADDRESS') && !this.formData['billingEmailAddress'])
                || (this.isFormEnabled('BILLING_ADDRESS_LINE_1') && !this.formData['billingAddressLine1']) || (this.isFormEnabled('BILLING_CITY') && !this.formData['billingCity'])
                || (this.isFormEnabled('BILLING_STATE_PROVINCE') && !this.formData['billingStateProvince']) || (this.isFormEnabled('BILLING_POSTAL_CODE') && !this.formData['billingPostalCode'])
                || (this.isFormEnabled('BILLING_COUNTRY') && !this.formData['billingCountry'])){
                return false;
            }
		        }
        return true;
        //check that the user name does not already exists.
    }

    isIndividualFormValid(){
        if((this.isFormEnabled('FIRST_NAME') && !this.formData['firstName']) || (this.isFormEnabled('LAST_NAME') && !this.formData['lastName']) || (this.isFormEnabled('EMAIL') && !this.formData['email'])){
            return false;
        }
        return true;
    }

    isOrganizationFormValid(){
        if((this.isFormEnabled('COMPANY_NAME') && !this.formData['companyName']) || (this.isFormEnabled('PRIMARY_CONTACT_FIRST_NAME') && !this.formData['primaryContactFirstName']) || (this.isFormEnabled('PRIMARY_CONTACT_LAST_NAME') && !this.formData['primaryContactLastName'])
            || (this.isFormEnabled('PRIMARY_CONTACT_EMAIL') && !this.formData['primaryContactEmail'])){
            return false;
        }
        return true;
    }

    isBillingComplianceChecked(){
       return this.formData['billingComplianceStatement'];
    }

    isMaximumRequestCostNumeric()
    {
        const patternRegex = /^\d{1,14}(\.\d{1,2})?$/;
        if (patternRegex.test(this.formData['maximumRequestCost'])){
            return true;
        }
        return false;
    }


    cancelRegistrationClicked(){
        this.cancelRegistration.emit({});
    }

    private setCountryOptions(response) {
        let countryOptions = [];
        if(response && response.countryOptions) {
            forEach(response.countryOptions, (key, value) => countryOptions.push({"label": key, "value": value}));
            countryOptions.sort(this.compare);
            this.country.options = countryOptions;
            this.billingCountry.options = countryOptions;
        }
    }

    private setFormMessages(response) {
        this.formMessages = response;
    }

    private setShowFormMessage(registrationType: string){
        if(registrationType == 'individual' && this.formMessages && this.formMessages['individual']) {
            this.formMessage = this.formMessages['individual'];
            this.showFormMessage = true;
        }
        else if(registrationType == 'organization' && this.formMessages && this.formMessages['organization']){
            this.formMessage = this.formMessages['organization'];
            this.showFormMessage = true;
        }
        else{
            this.showFormMessage = false;
        }
    }

    private compare(a, b) {
        if (a.label.toUpperCase() > b.label.toUpperCase()) return 1;
        if (b.label.toUpperCase() > a.label.toUpperCase()) return -1;
        return 0;
    }

    private setVisibilityMap(response){
        if(response && response.fieldsVisibility) {
            this.fieldsVisibilityMap = response.fieldsVisibility;
        }
    }

    private login(response){
        this.registerInProgress = false;
        this.loginUserDetails.emit({userName: this.formData['userName'], password: this.formData['password']});
    }

    private handleError(response){
        this.registerInProgress = false;
        this.showUserValidationMsg = true;
        this.userErrorMsg = response.data;
        this.$timeout(() => {
            let element = document.getElementById("user_validation_msg");
            if (element) {
                element.setAttribute('tabindex', '-1');
                element.focus();
                element.setAttribute('tabindex', '0');
            }
        }, 100);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/selfRegistration/selfRegistration.directive.ts